<template>
  <v-card class="stat-card rounded-lg" elevation="0" outlined>
    <div class="d-flex flex-column flex-lg-row align-center align-lg-center text-center text-lg-left pa-3 pa-sm-4">
      <v-avatar v-if="icon" :color="iconBg" :size="$vuetify.breakpoint.xsOnly ? 40 : 48" class="mb-2 mb-lg-0 mr-lg-3">
        <v-icon :color="color">{{ icon }}</v-icon>
      </v-avatar>
      <div class="flex-grow-1">
        <div class="stat-label text--secondary">{{ label }}</div>
        <div class="d-flex align-baseline justify-center justify-lg-start">
          <v-skeleton-loader v-if="loading" type="text" width="80" />
          <template v-else>
            <span class="stat-value" :title="fullValue">{{ formattedValue }}</span>
            <span v-if="unit" class="stat-unit ml-1 text--secondary">{{ unit }}</span>
          </template>
        </div>
        <div v-if="trend != null && !loading" class="stat-trend" :class="trend >= 0 ? 'up' : 'down'">
          <v-icon x-small :color="trend >= 0 ? 'green' : 'red'">
            {{ trend >= 0 ? "mdi-arrow-up" : "mdi-arrow-down" }}
          </v-icon>
          {{ Math.abs(trend) }}%
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
export default {
  name: "StatCard",
  props: {
    label: { type: String, required: true },
    value: { type: [Number, String], default: 0 },
    unit: { type: String, default: "" },
    icon: { type: String, default: "" },
    color: { type: String, default: "primary" },
    trend: { type: Number, default: null }, // percent delta, optional
    loading: { type: Boolean, default: false },
  },
  computed: {
    iconBg() {
      return "rgba(0, 189, 115, 0.12)";
    },
    // Compact notation (4.8M, 12.8K) so big numbers never wrap; small counts stay as-is.
    formattedValue() {
      if (typeof this.value === "number") {
        return new Intl.NumberFormat(undefined, {
          notation: "compact",
          maximumFractionDigits: 1,
        }).format(this.value);
      }
      return this.value;
    },
    // Full precision for the hover title.
    fullValue() {
      if (typeof this.value === "number") {
        return this.value.toLocaleString() + (this.unit ? ` ${this.unit}` : "");
      }
      return String(this.value);
    },
  },
};
</script>

<style scoped>
.stat-card {
  height: 100%;
}
.stat-label {
  font-size: 0.8rem;
  font-weight: 500;
}
.stat-value {
  font-size: 1.6rem;
  font-weight: 700;
  line-height: 1.2;
  white-space: nowrap;
}
@media (max-width: 599px) {
  .stat-value {
    font-size: 1.25rem;
  }
}
.stat-unit {
  font-size: 0.85rem;
}
.stat-trend {
  font-size: 0.75rem;
  font-weight: 600;
}
.stat-trend.up {
  color: #2e7d32;
}
.stat-trend.down {
  color: #c62828;
}
</style>
